var React = require('react');

function Tortilla2Inline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"25.9","cy":"25.9","r":"25.9","key":0}),React.createElement("path",{"d":"M252.7,124.1c15.2,15.2,15.2,39.7,0,54.9c-10.2,10.2-10,26.6,0,36.6c10,10,26.6,10,36.6,0c35.4-35.4,35.6-93,0-128.6\n\tc-35.4-35.4-93-35.6-128.6,0s-35.6,93,0,128.6c10.2,10.2,26.6,10,36.6,0c10-10,10-26.6,0-36.6c-15.2-15.2-15.2-39.7,0-54.9\n\tC212.9,108.9,237.7,109.1,252.7,124.1z","key":1})]);
}

Tortilla2Inline.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 315.9 223.2","style":{"enableBackground":"new 0 0 315.9 223.2"},"xmlSpace":"preserve"};

module.exports = Tortilla2Inline;

Tortilla2Inline.default = Tortilla2Inline;
